import { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { Toaster } from 'react-hot-toast';
import RootRouting from './routes/RootRouting';
import LoadingIndicator from './components/layout/LoadingIndicator';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading (replace with your actual loading logic)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Provider store={store}>
      <Router>
        {/* Show loading indicator while loading */}
        {isLoading && <LoadingIndicator />}
        
        {/* Main app content - always rendered but hidden when loading */}
        <div className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-300'}>
          <Toaster />
          <RootRouting />
        </div>
      </Router>
    </Provider>
  );
};

export default App;